export default __webpack_public_path__ + "images/caf20d6c380f96d178370c63bdaf8978-cc-mini-back.png";